export default __webpack_public_path__ + "static/3-70a773c5862dc9b44945b612e1eab62c.jpeg";